<template>
<!--        id: 7-->
<!--        introduce: "<p style="line-height: 36px;"><span style="font-family: 微软雅黑; font-size: 18px;">日前，由余杭区委统战部组织知联会员代表组成的服务团一行15人走进梦想小镇，为小镇新的社会阶层人士开展“三服务”活动。众创同心荟会员代表参加活动。</span></p><p style="text-align: center; line-height: 36px;"><img src="http://huicye.image.alimmdn.com/fedBackStage/2019092708541.png" alt="1" class=""/><span style="font-family: 微软雅黑; font-size: 18px;"><br/></span></p><p style="line-height: 36px;"><span style="font-family: 微软雅黑; font-size: 18px;">这支服务团由来自我区10余个政府职能部门的业务科室负责人、律师事务所负责人组成。在互动环节，服务团成员就参会人员提出的人才招引、人力社保、工商许可、企业税收减免、企业申请、办证注册、法律咨询、垃圾分类、交通环境等30余条涉及企业运营、学习生活方面的问题进行现场解答，还为新阶层人士在创业过程中遇见的问题和困惑出谋划策。</span></p><p style="text-align: center; line-height: 36px;"><img src="http://huicye.image.alimmdn.com/fedBackStage/2019092708542.png" alt="2"/><span style="font-family: 微软雅黑; font-size: 18px;"><br/></span></p><p style="line-height: 36px;"><span style="font-family: 微软雅黑; font-size: 18px;">活动现场气氛热烈，服务团耐心、细致、专业的服务得到参会人员的一致好评。新阶层人士王为松表示，这次专家上门“义诊”为他们排忧解难的同时也开阔了大家的眼界，创业的信心更加足了。希望今后能多举办这样的活动，让企业人员了解更多的创业信息和法律常识。</span></p><p style="text-align: center; line-height: 36px;"><img src="http://huicye.image.alimmdn.com/fedBackStage/2019092708543.png" alt="3"/><span style="font-family: 微软雅黑; font-size: 18px;"><br/></span></p><p><br/></p><p style="line-height: 36px;"><span style="font-family: 微软雅黑; font-size: 18px;">据悉，为推动“三服务”活动常态化进行，区知联会将继续围绕区委、区政府中心工作，充分发挥会员智力密集、人才荟萃优势，拟开展网上支教、赴贫困地区支教、送法律进社区、垃圾分类宣传等社会服务活动。</span></p><p><br/></p><p><br/></p>"-->
<!--        readnumber: 6-->
<!--        thumbnail: "https://uploadfile.huicye.com/test/img/company/temp/20200616/2020/6/4a673f737b3b473a8730bed2cb5d5f09.png"-->
<!--        time: 1592289306396-->
<!--        title: "余杭知联会员走进梦想小镇开展“三服务”活动"-->
    <div class="lp_list">
<!--        <div class="title"  v-if="isShowTitle">共<span>{{total}}</span>家企业</div>-->
        <div class="list" v-if="dataList&&dataList.length>0">
            <div class="item" v-for="(item,index) in dataList" :key="index" @click="itemClick(item,index)">
                <div class="left" >
                    <el-image :src="item.informThumbnail" fit="cover" v-if="typename==0||typename==2"></el-image>
                    <el-image :src="item.policyThumbnail" fit="cover" v-if="typename==1"></el-image>
                    <el-image :src="item.serviceThumbnail" fit="cover" v-if="typename==3"></el-image>
                    <el-image :src="item.thumbnailUrl" fit="cover" v-if="typename==10"></el-image>                                        
                </div>
<!--                根据不同页面使用不同字段//0-更多资讯列表，1-政策解读列表，2-申报通知列表,3-第三方服务-->
                <div class="right" v-if="typename==0">
                    <div class="name">{{ item.informName}}</div>
                    <p class="descTextP" v-if="item.informContent">{{ item.informSummary }}</p>
                    <p class="detailTextP"><span>发布时间：{{item.createTime | translatDateToDayPointStr}}</span><span>阅读量：{{Number(item.readCount || 0)+Number(item.originReadCount || 0) }}</span></p>
                </div>
                <div class="right" v-else-if="typename==1">
                    <div class="name">{{ item.policyName }}</div>
                    <!-- desc使用replace-部分文字没有加载出来，所以使用synopsisText-后台去掉标签之后的内容 -->
                    <p class="descTextP"  v-if="item.policySummary" v-html="item.policySummary"></p>
                    <!-- <p class="descTextP"  v-if="item.desc ">{{ item.desc.replace(/<\/?.+?\/?>/g,'').replace(/\&.+\;/mg,'') }}</p> -->
                    <p class="detailTextP"><span>发布时间：{{item.createTime | translatDateToDayPointStr}}</span><span>阅读量：{{Number(item.readCount || 0)+Number(item.originReadCount || 0) }}</span></p>
                </div>
                <div class="right" v-else-if="typename==2">
                    <div class="name">{{ item.informName }}</div>
                    <p class="descTextP"  v-if="item.informSummary ">{{ item.informSummary.replace(/<\/?.+?\/?>/g,'').replace(/\&.+\;/mg,'') }}</p>
                    <p class="detailTextP"><span>发布时间：{{item.createTime | translatDateToDayPoint}}</span><span>阅读量：{{Number(item.readCount || 0)+Number(item.originReadCount || 0) }}</span></p>
                </div>
                <div class="right" v-else-if="typename==3">
                    <div class="name">{{ item.serviceName }}</div>
                    <p class="descTextP"  v-if="item.serviceSummary ">{{ item.serviceSummary.replace(/<\/?.+?\/?>/g,'').replace(/\&.+\;/mg,'') }}</p>
                    <p class="detailTextP"><span>发布时间：{{item.createTime | translatDateToDayPoint}}</span><span>阅读量：{{Number(item.readCount || 0)+Number(item.originReadCount || 0) }}</span></p>
                </div>
                 <div class="right" v-else-if="typename==10">
                    <div class="name">{{ item.titleName }}</div>
                    <p class="descTextP"  v-if="item.synopsis ">{{ item.synopsis.replace(/<\/?.+?\/?>/g,'').replace(/\&.+\;/mg,'') }}</p>
                    <p class="detailTextP"><span>发布时间：{{item.createDate | translatDateToDayPoint}}</span></p>
                </div>
                <div class="right" v-else>
                </div>
            </div>
        </div>
        <lp-empty v-else></lp-empty>
    </div>
</template>

<script>
    export default {
        name: "lp_MoreInforList",
        props:{
            total:{//总数
                type:Number,
                default:0
            },
            isShowTitle:{
                type:Boolean,
                default:true
            },
            //数据
            dataList:{
                type:Array,
                default:()=>[]
            },
            //类型
            typename:{
                type:Number,
                default:0//0-更多资讯列表，1-政策解读列表，2-申报通知列表
            }
        },
        data () {
            return{

            }
        },
        methods: {
            //点击item
            itemClick(item,index){
                this.$emit('itemClick',item,index);
            }
        },
    }
</script>

<style scoped lang="less">
    .lp_list{
        .title{
            width: 100%;
            padding: 22px 30px;
            box-sizing: border-box;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #324059;
            letter-spacing: 0;
            border-bottom: 1px solid  #E5E5E5;
            span{
                font-size: 14px;
                color: #151515;
                letter-spacing: 0;
                font-weight: bold;
            }
        }
        .list{
            width: 100%;
            height: auto;
            .item{
                width: 100%;
                padding:24px 30px;
                box-sizing: border-box;
                border-bottom: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                cursor: pointer;
                .left{
                    width: 242px;
                    height: 160px;
                    border: 1px solid #eee;
                    box-sizing: border-box;
                    .el-image{
                        width: 100%;
                        height: 100%;
                    }
                }
                .right{
                    height: 140px;
                    flex: 1;
                    margin-left: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .name{
                        font-family: MicrosoftYaHei-Bold;
                        font-size: @fontBigSize;
                        color: @fontDefaultColor;
                        letter-spacing: 0;
                        font-weight: bold;
                    }
                    .name:hover{
                        color: @hoverDefaultColor;
                    }
                    p{
                        width: 100%;
                        word-break: break-all;
                    }

                    .descTextP{
                        margin-top: 10px;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: @fontDefaultColor;
                        letter-spacing: 0;
                        line-height: 20px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                        height: 40px;
                        // margin-bottom: 20px;
                    }
                    .detailTextP{
                        margin-top: 20px;
                        font-family: MicrosoftYaHei;
                        font-size: 12px;
                        color: @fontMediumColor;
                        letter-spacing: 0;
                        span{
                            margin-right: 48px;
                            font-size: 12px;
                            color: @fontMediumColor;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/moreinfor/index.vue